import { useEffect, useState } from "react";
import {
  Box,
  Tooltip,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
} from "@mui/material";
import styles from "./PlatformFetchStatus.module.css";

const PlatformFetchStatus = ({ fetchedDataStatus = [], type = "CURSOR" }) => {
  const userPlatform = JSON.parse(localStorage.getItem("user_platform"));
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!userPlatform) return;

    const matchedPlatform = fetchedDataStatus.find(
      (item) => item.platform === userPlatform
    );

    if (matchedPlatform) {
      setRows(matchedPlatform.cursorData || []);
    } else {
      setRows([]);
    }
  }, [fetchedDataStatus, userPlatform]);

  if (
    !userPlatform ||
    !fetchedDataStatus.length ||
    !fetchedDataStatus.some((item) => item.platform === userPlatform)
  ) {
    return null;
  }

  return (
    <div className={styles.container}>
      {fetchedDataStatus.map((platform, index) => {
        const isUserPlatform = platform.platform === userPlatform;
        if (!isUserPlatform) return null;

        const tooltipContent = platform?.cursorData?.length ? (
          <Box sx={{ p: 0.5 }}>
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 600,
                mb: 0.5,
                fontSize: "0.85rem",
                color: "text.primary",
              }}
            >
              {platform.name} — Cursor Details
            </Typography>

            <Table size="small" sx={{ "& td, & th": { fontSize: "0.85rem", p: 0.8 } }}>
              <TableHead>
                <TableRow sx={{ color: "#00000099" }}>
                  <TableCell sx={{ fontWeight: 600 }}>Data</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Last Upload</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Latest Sync</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows?.map((cursor, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{cursor.title}</TableCell>
                    <TableCell>{cursor.lastUpload}</TableCell>
                    <TableCell>{cursor.lastSync}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        ) : type === "CURSOR" ? (
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: 500,
              fontSize: "0.85rem",
              p: 1,
            }}
          >
            {platform.name} — No Cursor Data Found
          </Typography>
        ) : (
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: 500,
              fontSize: "0.85rem",
              p: 1,
            }}
          >
            Last Fetched At: {platform.lastFetch}
          </Typography>
        );

        return (
          <div
            key={index}
            className={`${styles.platformWrapper} ${
              isUserPlatform ? styles.activePlatform : ""
            }`}
          >
            <Tooltip
              title={tooltipContent}
              arrow
              placement="bottom"
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "background.paper",
                    color: "text.primary",
                    boxShadow: 3,
                    borderRadius: 2,
                    p: 1,
                    maxWidth: 400,
                  },
                },
              }}
            >
              <div
                className={`${styles.progressCircle} ${
                  platform.error ? styles.error : styles.success
                }`}
              >
                <div className={styles.backgroundRing}></div>
                <div className={styles.ring}></div>
                <img
                  src={platform.icon}
                  alt={platform.name}
                  className={styles.icon}
                />
              </div>
            </Tooltip>
          </div>
        );
      })}
    </div>
  );
};

export default PlatformFetchStatus;